export function getImageDimensionsFromBase64(base64Data) {
  // Decode base64 data
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  // Convert to an array of byte values
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Check for PNG image format (adjust for other formats if needed)
  if (
    byteArray[0] === 0x89 &&
    byteArray[1] === 0x50 &&
    byteArray[2] === 0x4e &&
    byteArray[3] === 0x47
  ) {
    // PNG format
    const width =
      (byteArray[16] << 24) |
      (byteArray[17] << 16) |
      (byteArray[18] << 8) |
      byteArray[19];
    const height =
      (byteArray[20] << 24) |
      (byteArray[21] << 16) |
      (byteArray[22] << 8) |
      byteArray[23];
    return { width, height };
  } else if (byteArray[0] === 0xff && byteArray[1] === 0xd8) {
    // JPEG format
    let offset = 2;
    while (offset < byteArray.length) {
      if (byteArray[offset] === 0xff && byteArray[offset + 1] === 0xc0) {
        // Found Start of Frame (SOF0)
        const height = (byteArray[offset + 5] << 8) | byteArray[offset + 6];
        const width = (byteArray[offset + 7] << 8) | byteArray[offset + 8];
        return { width, height };
      } else {
        offset += (byteArray[offset + 2] << 8) | byteArray[offset + 3]; // Move to the next marker
      }
    }
  } else if (
    byteArray[0] === 0x47 &&
    byteArray[1] === 0x49 &&
    byteArray[2] === 0x46
  ) {
    // GIF format
    const width = byteArray[6] | (byteArray[7] << 8);
    const height = byteArray[8] | (byteArray[9] << 8);
    return { width, height };
  } else {
    throw new Error("Unsupported image format");
  }
}

export function rgbToHex(rgb) {
  const result = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.exec(rgb);
  return result
    ? `FF${parseInt(result[1]).toString(16).padStart(2, "0")}${parseInt(
        result[2]
      )
        .toString(16)
        .padStart(2, "0")}${parseInt(result[3])
        .toString(16)
        .padStart(2, "0")}`.toUpperCase()
    : null;
}


export function getCurrentDateTime() {
  let currentDate = new Date();

  // Get day, month, year
  let day = currentDate.getDate().toString().padStart(2, "0");
  let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
  let year = currentDate.getFullYear();

  // Get hours, minutes, seconds
  let hours = currentDate.getHours().toString().padStart(2, "0");
  let minutes = currentDate.getMinutes().toString().padStart(2, "0");
  let seconds = currentDate.getSeconds().toString().padStart(2, "0");

  // Form the date string in the desired format
  let formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

  return formattedDateTime;
}


export const parseISODate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    console.warn('Invalid date string:', dateString);
    return new Date().getTime(); // Return current time as fallback
  }
  
  try {
    const cleanedDate = dateString.replace(' ', 'T');
    return new Date(cleanedDate).getTime();
  } catch (error) {
    console.error('Error parsing date:', dateString, error);
    return new Date().getTime(); // Return current time as fallback
  }
};